//sessions.ts

import { apiProvider } from "./utilities/provider";

const resource = "session";

export const sessionsApi = {
  start: (email: string, password: string) =>
    apiProvider.post(resource, { email, password }),
  end: () => apiProvider.remove(resource),
};
